module.exports = __webpack_public_path__ + "static/media/sa.0b58ee19.webp";